const ScanButton = ({ setModal, orderId }) => {
    return (
        <button
            onClick={() => {
                setModal({
                    open: true,
                    orderId: orderId,
                    customerName: orderId,
                });
            }}
            className="btn btn-sm badge bg-warning-transparent ms-1 w-25 py-2"
        >
            <i className="ri-qr-code-line me-1 fw-medium align-middle d-none d-md-inline"></i>
            SCAN
        </button>
    )
}

export default ScanButton;